import { Dispatch, useReducer } from 'react';

export type ObjectReducerAction<T> = Partial<T> | ((state: T) => Partial<T>);

const objectReducer = <T extends object>(state: T, action: ObjectReducerAction<T>): T => {
  const patch = typeof action === 'function' ? action(state) : action;

  return {
    ...state,
    ...patch
  };
};

export default function useObjectReducer<T extends object>(
  initialStateOrFactory: T | (() => T)
): [T, Dispatch<ObjectReducerAction<T>>] {
  return useReducer(
    objectReducer<T>,
    initialStateOrFactory,
    (initialState): T =>
      typeof initialState === 'function' ? (initialState as () => T)() : initialState
  );
}
